import {JackpotAmountPreviewDefaultBox} from './jackpot-amount-preview.default.box';
import {JackpotAmountPreviewCasino777Box} from './jackpot-amount-preview.casino777.box';
import {styledByTheme} from '../../../../../../../themes/architecture/styled-by-theme';

export const JackpotAmountPreviewBox = styledByTheme(JackpotAmountPreviewDefaultBox).forCasino777(JackpotAmountPreviewCasino777Box).apply();